<div class="d-flex justify-content-center align-items-center w-100 h-100">
  <div class="spinner-grow text-secondary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
